import {
  keepPreviousData,
  MutationCache,
  QueryCache,
  QueryClient,
} from '@tanstack/react-query';

type QueryErrorHandler = (error: any) => void;

const handlePasswordReset: QueryErrorHandler = (error) => {
  if (error?.status === 418) {
    localStorage.removeItem('cms.user');
    window.location.replace('/login');
  }
};

const queryErrorHandlers: QueryErrorHandler[] = [handlePasswordReset];

const handleError = (error: any) => {
  queryErrorHandlers.forEach((handler) => handler(error));
};

export const queryClient = new QueryClient({
  queryCache: new QueryCache({
    onError: handleError,
  }),
  mutationCache: new MutationCache({
    onError: handleError,
  }),
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      placeholderData: keepPreviousData,
    },
  },
});
